
/* This files contains all routes in constants */

export const HOME_ROUTE = "/" ;
export const CHOOSE_PLAN_ROUTE = "/choose-plan" ;
export const LOGIN_ROUTE  = "/login" ;
export const SIGNUP_ROUTE = "/signup" ;
export const SETUP_ACCOUNT_STEP_ONE_ROUTE = "/setup-account-step-1" ;
export const SETUP_ACCOUNT_STEP_TWO_ROUTE = "/setup-account-step-2" ;
export const CONTACT_US = "/contact-us" ;
export const SUCCESS_PAGE_ROUTE = "/success";
export const FAIL_PAGE_ROUTE = "/fail"
export const DASHBOARD_ROUTE = "/dashboard" ;
export const FORGOT_PASSWORD_ROUTE = "/forgot-password" ;
export const TERMS_AND_CONDITIONS = "/terms-and-condition" ;
export const FREE_ALERTS_BANNER = "/free-alerts" ;
export const SUPER_ADMIN_LOGIN_ROUTE = "/superadmin-login" ;
export const SUPER_ADMIN_OTP_ROUTE = "/superadmin-verify" ;
export const PAGE_NOT_FOUND_ROUTE = "/404" ;
export const TEST_ROUTE = "/test" ;